/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionBody_org = {
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyAutopilot_org" | "SuggestionBodyConfigColors_org" | "SuggestionBodyConflictingMeeting_org" | "SuggestionBodyExpensiveMeeting_org" | "SuggestionBodyExpensiveOrganizer_org" | "SuggestionBodyLowFocusTime_org" | "SuggestionBodyOutOfOffice_org" | "SuggestionBodyWeeklyAutopilotSummary_org">;
    readonly " $refType": "SuggestionBody_org";
};
export type SuggestionBody_org$data = SuggestionBody_org;
export type SuggestionBody_org$key = {
    readonly " $data"?: SuggestionBody_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBody_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBody_org",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyAutopilot_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyConfigColors_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyConflictingMeeting_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyExpensiveMeeting_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyExpensiveOrganizer_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyLowFocusTime_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyOutOfOffice_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestionBodyWeeklyAutopilotSummary_org"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '8a35f67a8c7466079124cc3158a04687';
export default node;
